export type AuthStatus = "loading" | "loggedOut" | "authenticated" | "expired";

export interface AuthState {
    status: AuthStatus;
    hadAuthenticatedSession: boolean;
}

export type AuthEvent =
    | { type: "storedKeyMissing" }
    | { type: "identityLoaded" }
    | { type: "authRejected" }
    | { type: "transientError" }
    | { type: "sessionCleared" };

export interface AuthDecision {
    state: AuthState;
    clearStoredKey: boolean;
}

export function isAuthRejection(err: unknown): boolean {
    const status = (err as { status?: number })?.status;
    return status === 401 || status === 403;
}

export function initialAuthState(hasStoredKey: boolean): AuthState {
    return { status: hasStoredKey ? "loading" : "loggedOut", hadAuthenticatedSession: false };
}

const LOGGED_OUT: AuthDecision = {
    state: { status: "loggedOut", hadAuthenticatedSession: false },
    clearStoredKey: true,
};

export function nextAuthState(state: AuthState, event: AuthEvent): AuthDecision {
    switch (event.type) {
        case "identityLoaded":
            return { state: { status: "authenticated", hadAuthenticatedSession: true }, clearStoredKey: false };
        case "storedKeyMissing":
            return { state: { ...state, status: "loggedOut" }, clearStoredKey: false };
        case "transientError":
            return { state, clearStoredKey: false };
        case "authRejected":
            return state.hadAuthenticatedSession
                ? { state: { status: "expired", hadAuthenticatedSession: true }, clearStoredKey: false }
                : LOGGED_OUT;
        case "sessionCleared":
            return LOGGED_OUT;
    }
}
